import React, { useState } from 'react';
import { debounce } from '../utils';
import useEnhancedEffect from './useEnhancedEffect';

const useWindowSize = function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useEnhancedEffect(() => {
    const updateSize = debounce(() => {
      setSize([window.innerWidth, window.innerHeight]);
    }, 200);
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
};

export default useWindowSize;